import { newDate } from 'date-fns-jalali';

export function jalaliToGregorian(jalaliDate: string): string {
    const [jy, jm, jd] = jalaliDate.split('-').map(Number);

    const gregorian = newDate(jy, jm - 1, jd);

    const year = gregorian.getFullYear();
    const month = String(gregorian.getMonth() + 1).padStart(2, '0');
    const day = String(gregorian.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}
